import React, { useEffect, useState } from "react";
import "./index.less";
import ActivityTable from "./activityTypesTable";
import { useSelector } from "react-redux";

const Departments = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);

  useEffect(() => {
    if (user?.permissions?.departments?.add_edit) {
      setCanUpdate(true);
    }
  }, [user]);

  return (
    <div className="page-top-div">
      <span className="text-span">Departments</span>
      <ActivityTable canUpdate={canUpdate}/>
    </div>
  );
};

export default Departments;
